var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApollo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:currentColor}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8416",
    transform: "translate(-26 -705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7439",
    fill: "none",
    d: "M0 0H31V31H0z",
    transform: "translate(26 705)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8416-2",
    transform: "translate(28.041 707.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4330",
    transform: "translate(5.09 13.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    d: "M270.957 215.078L260.4 225.563a12.746 12.746 0 0 0 1.391.9 13.856 13.856 0 0 0 6.932 1.7 15.9 15.9 0 0 0 2.233-.167z",
    className: "cls-1",
    transform: "translate(-260.401 -215.078)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    d: "M276.34 197.119a12.373 12.373 0 0 0-4.763-4.754 13.629 13.629 0 0 0-6.859-1.7 13.865 13.865 0 0 0-6.921 1.743 12.158 12.158 0 0 0-4.73 4.787 15.1 15.1 0 0 0 .047 13.9 12.543 12.543 0 0 0 1.139 1.688l13.247-13.154a1.555 1.555 0 0 1 2.65 1.1v15.827a12.692 12.692 0 0 0 1.553-.753 12.2 12.2 0 0 0 4.706-4.787 15 15 0 0 0-.071-13.9z",
    className: "cls-1",
    transform: "translate(-251.397 -190.669)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApollo);
export default __webpack_public_path__ + "static/media/apollo.85309e038887452764b35cd10b627bc2.svg";
export { ForwardRef as ReactComponent };